const updates = [
  { id: 1, date: '2026-07-30', time: '14:22', text: '某顶流男星被拍到深夜与神秘女子同回酒店，粉丝集体炸锅', tag: '明星恋情' },
  { id: 2, date: '2026-07-30', time: '11:05', text: '知名带货主播直播间产品被网友实锤成分造假，品牌方紧急回应', tag: '网红翻车' },
  { id: 3, date: '2026-07-29', time: '20:48', text: '热播综艺节目导演被曝私下收受选手贿赂操控比赛结果', tag: '综艺争议' },
  { id: 4, date: '2026-07-29', time: '16:30', text: '某美妆品牌被消费者集体投诉，使用后多人出现严重过敏反应', tag: '品牌塌房' },
  { id: 5, date: '2026-07-28', time: '09:15', text: '网传某知名演员税务问题再升级，涉事金额或达数亿元', tag: '明星八卦' },
  { id: 6, date: '2026-07-27', time: '22:00', text: '直播界一哥与平台合约到期，去向成谜引多方猜测', tag: '直播圈内幕' },
  { id: 7, date: '2026-07-27', time: '15:42', text: '素人网友曝光某连锁餐饮品牌后厨卫生状况触目惊心', tag: '素人爆料' },
  { id: 8, date: '2026-07-26', time: '18:10', text: '选秀节目出道选手被前公司控诉违约，出道资格或受影响', tag: '综艺争议' },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
              <i className="ri-timer-flash-line"></i> 实时追踪
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">
              最新快讯
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto leading-relaxed">
              每日追踪全网最新八卦动态，让你永远走在吃瓜第一线
            </p>
          </div>

          <div className="max-w-[800px] mx-auto">
            <div className="relative pl-8 md:pl-10">
              {/* Timeline line */}
              <div className="absolute left-[15px] md:left-[19px] top-2 bottom-2 w-0.5 bg-background-300"></div>

              <div className="space-y-8">
                {updates.map((update, idx) => (
                  <div key={update.id} className="relative">
                    {/* Timeline dot */}
                    <div className={`absolute -left-[23px] md:-left-[27px] top-1.5 w-4 h-4 rounded-full border-2 border-background-50 ${
                      idx < 2 ? 'bg-primary-500 shadow-[0_0_0_4px_rgba(var(--primary-500),0.2)]' : 'bg-secondary-300'
                    }`}></div>

                    <div className="bg-background-100 rounded-xl p-5 hover:bg-background-200/70 transition-colors">
                      <div className="flex items-center gap-3 mb-2 flex-wrap">
                        <span className="text-xs text-foreground-500 font-mono">
                          {update.date} {update.time}
                        </span>
                        <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                          idx < 2
                            ? 'bg-primary-100 text-primary-700'
                            : 'bg-secondary-100 text-secondary-700'
                        }`}>
                          {update.tag}
                        </span>
                        {idx < 2 && (
                          <span className="px-2 py-0.5 rounded-full text-[10px] font-bold bg-accent-500 text-background-50 whitespace-nowrap">
                            HOT
                          </span>
                        )}
                      </div>
                      <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                        {update.text}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}